import Icon from '@mui/material/Icon';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import _ from '@lodash';
import {useTranslation} from 'react-i18next';
import { Divider } from '@mui/material';

function JobsHelpersHeaderBilling({
  id,
  jsonGetById,
  setEditJobBillingOpen,
  setJob_id,
  job_id,
  data,
}) {
  const theme = useTheme();
  const {t} = useTranslation('navigation');

  return (
    <div className="flex sm:flex-row flex-col w-full items-center justify-between newjob-next">
      <div className="lg:w-3/6 md:w-3/6">
        <motion.div
          initial={{ x: 20, opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}
        >
          {data ? (
            <Typography
              className="flex items-center sm:mb-12 backjobs"
              role="button"
              color="black"
              onClick={() => {
                setEditJobBillingOpen(false);
              }}
            >
              <Icon className="text-20">
                {theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}
              </Icon>
              <span className="sm:flex mx-4 font-medium">{t('BACK_TO_JOBS_OVERVIEW')}</span>
            </Typography>
          ) : (
            <Typography
              className="flex items-center sm:mb-12 backjobs"
              component={Link}
              role="button"
              to="/jobs"
              color="black"
            >
              <Icon className="text-20">
                {theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}
              </Icon>
              <span className="sm:flex mx-4 font-medium">{t('BACK_TO_JOBS_OVERVIEW')}</span>
            </Typography>
          )}
        </motion.div>

        <div className="">
          <div className="flex sm:flex-col flex-row min-w-0 mx-8 sm:mc-16 mobile-mt-0">
            <motion.div
              initial={{ x: -20 }}
              animate={{ x: 0, transition: { delay: 0.3 } }}
              className="sm:mt-0 mt-32 mobile-mt-0"
            >
              <Typography
                variant="h4"
                color="black"
                className="jobheading"
              >
                {id || job_id
                  ? `${t('JOB_NO')} ${localStorage.getItem('job_duplicate') ? JSON.parse(localStorage.getItem('job_duplicate'))[0].job_no : jsonGetById.length > 0 ? jsonGetById[0].job_no : null}`
                  : t('NEW_JOB')}
              </Typography>
              <Typography
                variant="caption"
                className="job-billing"
                color="black"
              >
                {localStorage.getItem('job_duplicate') ? null : jsonGetById.length > 0 && jsonGetById[0].bol_type == true  ? t('BILL_OF_LADING_BILLING_DETAILS') : t('JOB_BILLING_DETAILS')}
                {
                localStorage.getItem('job_duplicate') ?
                <div className='flex flex-col mt-16 w-2/5' >
                  <Divider></Divider>
                  <div className='flex flex-row  justify-start items-center'>
                    <Icon sx={{fontSize:'22px !important'}}>info</Icon>
                    <Typography variant='caption' className='job-billing pl-8' color='black'>
                      This is a duplicate
                    </Typography>
                  </div>
                  <Typography variant='caption' className='job-billing ml-16' color='black'>
                    This job is a duplicate of Job No. {JSON.parse(localStorage.getItem('job_duplicate'))[0].duplicate_from}
                  </Typography>
                  <Divider></Divider>

                </div>
                :null
              }
              </Typography>
            </motion.div>
          </div>
        </div>
      </div>
      {/* <motion.div
        className="flex sm:flex-row mb-32 right buttons"
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0, transition: { delay: 0.3 } }}
      >
        <Button
          style={{color:"white"}} 
          className="whitespace-nowrap mx-4 "
          variant="contained"
          color="third"
          onClick={handleCancelCreateJob}
          startIcon={<Icon className="hidden sm:flex">cancel</Icon>}
        >
          Cancel
        </Button>
 
        <Button
          style={{color:"white"}}
          className="whitespace-nowrap mx-4"
          variant="contained"
          color="third"
          disabled={!isValid || disabled}
          onClick={jsonGetById.length > 0 ?  jsonGetById[0].job_billing ? handleUpdateJob : f : null}
        >
          {jsonGetById.length > 0 ?  jsonGetById[0].job_billing ? 'Update' : 'Create' : 'Create'}
        </Button>
      </motion.div> */}
    </div>
  );
}

export default JobsHelpersHeaderBilling;
